/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WardBasedDefaultServiceApi } from '../api/wardbaseddefaultservice.api';
import { WardBasedDefaultService, WardBasedDefaultServiceData } from '../../../interfaces/masters/Ward-Based-Default-Service';

@Injectable()
export class WardBasedDefaultServcService extends WardBasedDefaultServiceData {

  constructor(private api: WardBasedDefaultServiceApi) {
    super();
  }


  list(url: string): Observable<any> {
    return this.api.list(url);
  }
  
  create(url: string, data:WardBasedDefaultService): Observable<WardBasedDefaultService[]> {
    return this.api.add(url,data);
  }

//   getById(url:string): Observable<WardBasedDefaultService>{
//       return this.api.getById(url);
//   }

 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
